import { render } from "./UrbanGreeneryAndAirQualityView.vue?vue&type=template&id=6474294c&scoped=true"
import script from "./UrbanGreeneryAndAirQualityView.vue?vue&type=script&lang=js"
export * from "./UrbanGreeneryAndAirQualityView.vue?vue&type=script&lang=js"

import "./UrbanGreeneryAndAirQualityView.vue?vue&type=style&index=0&id=6474294c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6474294c"]])

export default __exports__